import { Button, Text } from "@chakra-ui/react";
import React from "react";

import { downloadFile } from "@nens/shared-utils";

export const ExplainLabDataFile: React.FC = () => {
  return (
    <>
      <Text pb="5">
        Gebruik deze optie om de labgegevens aan te leveren. Zorg ervoor dat u het format in het
        volgende template hanteert. Niet alle stoffen hoeven gemeten te worden. Wanneer een stof
        niet gemeten is, dan kunt u deze kolommen verwijderen.
      </Text>
      <Button
        variant="primary"
        onClick={() => downloadFile("/files/garLabDataTemplate.xlsx", "garLabDataTemplate.xlsx")}
      >
        Download Excel-template
      </Button>
    </>
  );
};
